import React from "react";

const PriceSectionCardSkeleton = () => (
    <div className="col-lg-4 col-12 mb-4">
        <div className="price-skeleton-outer p-3">

            {/* Header */}
            <div className="d-flex justify-content-center mb-4">
                <div className="skeleton skeleton-title"></div>
            </div>

            {/* Plan name + description */}
            <div className="mt-3">
                <div className="skeleton skeleton-title"></div>
                <div className="skeleton skeleton-subtitle"></div>
            </div>

            {/* Price */}
            <div className="mt-3">
                <div className="skeleton skeleton-title" ></div>
                <div className="skeleton skeleton-subtitle"></div>
            </div>

            {/* Buy Now Button */}
            <div className="mt-4">
                <div className="skeleton" style={{ width: "120px", height: "36px", borderRadius: "20px" }}></div>
            </div>

            {/* Features List */}
            <div className="mt-4">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="d-flex gap-2 mb-2 align-items-center">
                        <div className="skeleton" style={{ width: "16px", height: "16px", borderRadius: "50%" }}></div>
                        <div className="skeleton-box" style={{ width: "80%", height: "14px" }}></div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default PriceSectionCardSkeleton;
